import * as React from "react";
import "./Icon.css";

const SvgAnnouncementIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Announcement_Icon_svg_Layer_1"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>
        {
          ".Announcement_Icon_svg_cls-1{fill:currentColor;stroke:currentColor;stroke-linejoin:round}"
        }
      </style>
    </defs>
    <g transform="translate(0,8)">
      <path
        d="m13.95 26.21 22.09-5.96V6.46L13.95.5zM41.52 6.5h5.98v23.01h-5.98zM1.825 2.412 2.846.954l7.184 5.03-1.02 1.459zM1.822 24.297l7.184-5.03 1.021 1.458-7.184 5.03zM.5 12.47h9.03v1.78H.5z"
        className="Announcement_Icon_svg_cls-1"
      />
    </g>
  </svg>
);
export default SvgAnnouncementIcon;
